import { InjectionToken } from '@angular/core';

/**
 * Bridge to AngularJS `UserPreferencesService`.
 *
 * CalendarService only uses `getDateFormat` to resolve the user's preferred
 * short-date format when stamping range labels. The legacy service is wider
 * than this — the port only exposes what the calendar needs.
 */
export interface IUserPreferencesPort {
  getDateFormat(type: string, format?: string): string;
}

export const USER_PREFERENCES_PORT = new InjectionToken<IUserPreferencesPort>(
  'USER_PREFERENCES_PORT',
);
